import React from 'react';
import { Button, Modal, Toast, Badge, Icon } from 'antd-mobile';
import {post} from '../../utils/request';
import cookies from 'js-cookie';
import api from './api';
import { wxfx } from '../../utils/wxfx.js';

import './index.less';

class CarBillDetails extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            imgShow: false,
            selectImg: '',
            urlOps:{},
            otherData: {
                lease: {},
                deliverys: [],
                licenseList: [],
                toolList: [],
                carInspectionList: [],
            },//其他信息
        };
    }

    componentDidMount() {
        document.getElementsByTagName('body')[0].style.cssText = 'background: #F4F4F5 !important';
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            // if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
            //     Toast.fail('请登录APP再进行操作',999);
            //     return;
            // }
            console.log(ops)
            if(ops.type == 2){
                document.getElementsByTagName('title')[0].text = '收车单'
            }else{
                document.getElementsByTagName('title')[0].text = '交车单'
            }
            this.setState({
                urlOps: ops
            },()=>{
                // this.queryOperateDetail();
                this.selectCarInspectionListByLinkId();
            });
        }
    }

    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是否web应该程序，没有头部与底部
        };
    }

    appShare(ops, shareType) {
        let viewPort = this.viewPort();
        if (
            viewPort.ios ||
            viewPort.iPhone ||
            viewPort.iPad
        ) {
            if(window.webkit){
                if(shareType){
                    window.webkit.messageHandlers.showShare.postMessage(ops);
                }else{
                    window.webkit.messageHandlers.share.postMessage(ops);
                }
            }
        } else {
            if(window.huilian){
                if(shareType){
                    window.huilian.showShareWeixin(ops.url, ops.title, ops.cotent, ops.img);
                }else{
                    window.huilian.shareWeixin(ops.url, ops.title, ops.cotent, ops.img);
                }
            }
        }
    }

    formatData(data) {
        const deliveryKey = [{
            type:'0',
            delivery:'保证金',
        },
        {
            type:'0',
            delivery:'喷漆',
        },
        {
            type:'1',
            delivery:'商业保险',
        },
        {
            type:'0',
            delivery:'首期租金',
        },
        {
            type:'1',
            delivery:'交强险',
        },
        {
            type:'0',
            delivery:'电桩',
        }];        

        const unit = {
            'YEAR': '年',
            'MONTH': '月',
            'DAY': '天'
        }

        const newData = Object.assign({
            deliverys: [],
            leasetypeUnit: unit[data.lease.unit],
        }, data);
        deliveryKey.map((item, index) => {
            if(index != 0 && index != 3){
                newData.deliverys.push({
                    key: index,
                    name: item.delivery,
                    type: item.type,
                    value: data && data.deliverycheck ? data.deliverycheck.substr(index,1) === '1' : null
                });
            }
        });

        return newData;
    };

    selectCarInspectionListByLinkId(){
        var {id, type, app_stoken, access_token} = this.state.urlOps;
        let url = '';
        let ops = '';
        if(access_token && access_token !== 'null' && access_token !== '(null)' && access_token !== 'undefined'){
            url = api.CXHselectCarInspectionListByLinkId + '?access_token=' + access_token;
            ops = 'access_token=' + access_token;
        }
        if(app_stoken && app_stoken !== 'null' && app_stoken !== '(null)' && app_stoken !== 'undefined'){
            url = api.selectCarInspectionListByLinkId + '?app_stoken=' + app_stoken;
            ops = 'app_stoken=' + app_stoken;
        }
        post({
            url: url, 
            data: {
                checkType: type == 1 ? 'DELIVERY' : 'RETURN',
                linkId: id
            }
        }).then((res) => {
            console.log('验车详细查询', res);
            if(res.result === 'success'){
                var data = res.data;
                // data.attachment = data.attachment ? JSON.parse(data.attachment) : [];
                data.lease = data.lease ? JSON.parse(data.lease) : {};
                this.setState({
                    otherData: this.formatData(data)
                });
                
                wxfx({
                    title: `您有一份${this.state.urlOps.type === '2' ? '收车单' : '交车单'}请查收`,
                    imgUrl: 'https://image.tf56.com/dfs/group1/M00/4E/78/CiFCK1-GUBKAQES0AADcFr9gEbk485.png',
                    desc: `${this.state.urlOps.type === '2' ? data.returnCarDate : data.rentDate}`,
                    url: `${window.location.origin}${window.location.pathname}#/carBillDetails?id=${this.state.urlOps.id}&type=${this.state.urlOps.type}&${ops}`
                });
                this.appShare({
                    title: `您有一份${this.state.urlOps.type === '2' ? '收车单' : '交车单'}请查收`,
                    url: `${window.location.origin}${window.location.pathname}#/carBillDetails?id=${this.state.urlOps.id}&type=${this.state.urlOps.type}&${ops}`,
                    cotent: `${this.state.urlOps.type === '2' ? data.returnCarDate : data.rentDate}`,
                    img:'https://image.tf56.com/dfs/group1/M00/4E/78/CiFCK1-GUBKAQES0AADcFr9gEbk485.png'
                }, true);
            }else{
                Toast.info('验车详细查询失败',1);
            }
        }, (res)=>{
            // console.log(res)
            Toast.info('验车详细查询失败',1);
        });
    }

    handleChange(type, i, item) {
        this.state.otherData[type][i] = item;
        this.setState({
            otherData:this.state.otherData
        });
            
    }

    render() {
        let _this = this;
        var {urlOps} = this.state;
        var {licenseList, toolList, carInspectionList, carPlateNumber, deliveryMiles, returnMiles, returnCarType, returnCarDate, customerSign, bizSign, attachment, lease, leasetypeUnit, rentDate,rentDateEnd, deliverys, memo} = this.state.otherData;
        return (
            <div className="CarBillDetailsBox">
                {
                    urlOps.type === '1' ? (
                        <div>
                            <h2>基本信息</h2>
                            <div className="blockBox">
                                {
                                    deliverys.map((item,index)=>{
                                        if(item.type === '1'){
                                            return (
                                                <div className="tag" key={index}>
                                                    {item.name}
                                                    <span>符合</span>
                                                </div>
                                            )
                                        }
                                    })
                                }
                            </div>
                            <div className="blockBox">
                                <div className="block-mini">
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>车牌号</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{carPlateNumber}</span>
                                        </div>
                                    </div>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>租期</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{lease.num ? lease.num + leasetypeUnit : '--' }</span>
                                        </div>
                                    </div>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>交车时间</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{rentDate ? rentDate : '--'}</span>
                                        </div>
                                    </div>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>计划还车时间</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{rentDateEnd ? rentDateEnd : '--'}</span>
                                        </div>
                                    </div>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>附件服务</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{deliverys.map(item=>{
                                                if(item.type === '0'){
                                                    return (item.name)
                                                }
                                            })}</span>
                                        </div>
                                    </div>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>实时里程(km)</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{deliveryMiles}</span>
                                        </div>
                                    </div>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>备注</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{memo ? memo : '--'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <h2>基本信息</h2>
                            <div className="blockBox">
                                <div className="block-mini" style={{paddingBottom: '0.12rem'}}>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>车牌号</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{carPlateNumber}</span>
                                        </div>
                                    </div>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>租期</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{lease.num ? lease.num + leasetypeUnit : '--' }</span>
                                        </div>
                                    </div>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>收车方式</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{['正常收车', '强制收车', '合同解除收车', '协议收车'][returnCarType]}</span>
                                        </div>
                                    </div>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>收车时间</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{returnCarDate}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="block-mini" style={{borderTop: '1px solid #EBEBEB',paddingTop:'0.16rem'}}>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>收车实时里程(km)</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{returnMiles || 0}</span>
                                        </div>
                                    </div>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>交车实时里程(km)</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{deliveryMiles || '--'}</span>
                                        </div>
                                    </div>
                                    <div className="block-mini-content">
                                        <div className="textLeft">
                                            <span>累计里程(km)</span>
                                        </div>
                                        <div className="textRight">
                                            <span>{(returnMiles || 0) - (deliveryMiles || 0)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                
                {
                    licenseList && licenseList.length> 0 ? (<div>
                        <h2>配件_证件清单</h2>
                        {licenseList.map((item,i)=>{
                            return (
                                <div className="blockBox" key={item.checkItemCode}>
                                    <div className="block">
                                        <div className="textLeft">
                                            <span>{item.checkItem}</span>
                                        </div>
                                        {
                                            item.checkResult == 1 ? (
                                                <div className="textRight success">
                                                    正常
                                                </div>
                                            ) : (
                                                    <div className="textRight error" onClick={()=>{
                                                        if(item.checkDetail){
                                                            item.direction = !item.direction;
                                                            _this.handleChange('licenseList', i, item);
                                                        }
                                                    }}>
                                                        丢失/损坏
                                                        { item.checkDetail && JSON.parse(item.checkDetail).length > 0 ? (<Icon type={item.direction ? 'up':'down'} color="#CCC" size="xxs" />) : '' }
                                                    </div>
                                                )
                                        }
                                    </div>
                                    {
                                        licenseList[i].direction ? (
                                            <div>
                                                {JSON.parse(item.checkDetail).map((obj,index)=>{
                                                    return (
                                                        <div className="block-mini" key={index}>
                                                            <hr />
                                                            <div className="block-mini-content">
                                                                <div className="textLeft">
                                                                    <span>费用</span>
                                                                </div>
                                                                <div className="textRight">
                                                                    <span>{obj.fee || 0}元</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                {
                                                    item.accessory ? (
                                                        <div className="block-mini">
                                                            <div className="block-mini-title">
                                                                <h3>相关图片</h3>
                                                            </div>
                                                            <div className="block-mini-content">
                                                                <div className="IMGBox">
                                                                    {
                                                                        JSON.parse(item.accessory).map((obj,index)=>{
                                                                            var minImg = obj.dataImg.replace('.jpg', '_240x320.jpg').replace('.png', '_240x320.png').replace('.jpeg', '_240x320.jpeg');
                                                                            return (
                                                                                <div className="img" key={index} style={{background: `url(${minImg}) no-repeat 0 0`, backgroundSize: 'cover'}} onClick={()=>{
                                                                                    _this.setState({
                                                                                        selectImg: obj.dataImg,
                                                                                        imgShow: true,
                                                                                    },()=>{
                                                                                        document.getElementsByTagName('body')[0].style.cssText = 'overflow: hidden;';
                                                                                    });
                                                                                }}></div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : ''
                                                }
                                            </div>
                                        ) : ''
                                    }
                                </div>
                            )
                        })}
                    </div>) : ''
                }

                {
                    toolList && toolList.length> 0 ? (<div>
                        <h2>配件_工具清单</h2>
                        {toolList.map((item, i)=>{
                            return (
                                <div className="blockBox" key={item.checkItemCode}>
                                    <div className="block">
                                        <div className="textLeft">
                                            <span>{item.checkItem}</span>
                                        </div>
                                        {
                                            item.checkResult == 1 ? (
                                                <div className="textRight success">
                                                    正常
                                                </div>
                                            ) : (
                                                    <div className="textRight error" onClick={()=>{
                                                        if(item.checkDetail){
                                                            item.direction = !item.direction;
                                                            _this.handleChange('toolList', i, item);
                                                        }
                                                    }}>
                                                        丢失/损坏
                                                        { item.checkDetail && JSON.parse(item.checkDetail).length > 0 ? (<Icon type={item.direction ? 'up':'down'} color="#CCC" size="xxs" />) : '' }
                                                    </div>
                                                )
                                        }
                                    </div>
                                    {
                                        item.direction ? (
                                            <div>
                                                {JSON.parse(item.checkDetail).map((obj,index)=>{
                                                    return (
                                                        <div className="block-mini" key={index}>
                                                            <hr />
                                                            <div className="block-mini-content">
                                                                <div className="textLeft">
                                                                    <span>费用</span>
                                                                </div>
                                                                <div className="textRight">
                                                                    <span>{obj.fee || 0}元</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                {
                                                    item.accessory ? (
                                                        <div className="block-mini">
                                                            <div className="block-mini-title">
                                                                <h3>相关图片</h3>
                                                            </div>
                                                            <div className="block-mini-content">
                                                                <div className="IMGBox">
                                                                    {
                                                                        JSON.parse(item.accessory).map((obj,index)=>{
                                                                            var minImg = obj.dataImg.replace('.jpg', '_240x320.jpg').replace('.png', '_240x320.png').replace('.jpeg', '_240x320.jpeg');
                                                                            return (
                                                                                <div className="img" key={index} style={{background: `url(${minImg}) no-repeat 0 0`, backgroundSize: 'cover'}} onClick={()=>{
                                                                                    _this.setState({
                                                                                        selectImg: obj.dataImg,
                                                                                        imgShow: true,
                                                                                    },()=>{
                                                                                        document.getElementsByTagName('body')[0].style.cssText = 'overflow: hidden;';
                                                                                    });
                                                                                }}></div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : ''
                                                }
                                            </div>
                                        ) : ''
                                    }
                                </div>
                            )
                        })}
                    </div>) : ''
                }

                {
                    carInspectionList && carInspectionList.length> 0 ? (<div>
                        <h2>车况检查</h2>
                        {carInspectionList.map((item, i)=>{
                            return (
                                <div className="blockBox" key={item.checkItemCode}>
                                    <div className="block">
                                        <div className="textLeft">
                                            <span>{item.checkItem}</span>
                                        </div>
                                        {
                                            item.checkResult == 1 ? (
                                                <div className="textRight success">
                                                    正常
                                                </div>
                                            ) : (
                                                    <div className="textRight error" onClick={()=>{
                                                        if(item.checkDetail){
                                                            item.direction = !item.direction;
                                                            _this.handleChange('carInspectionList', i, item);
                                                        }
                                                    }}>
                                                        异常
                                                        { item.checkDetail ? (<Icon type={item.direction ? 'up':'down'} color="#CCC" size="xxs" />) : '' }
                                                    </div>
                                                )
                                        }
                                    </div>
                                    {
                                        item.direction ? (
                                            <div>
                                                {JSON.parse(item.checkDetail).map((obj,index)=>{
                                                    return (
                                                        <div className="block-mini" key={index}>
                                                            <div className="block-mini-title" key={obj.item}>
                                                                <span>{obj.item}</span>
                                                            </div>
                                                            <div className="block-mini-content">
                                                                <div className="textLeft">
                                                                    <span>数量</span>
                                                                </div>
                                                                <div className="textRight">
                                                                    <span>{obj.place || 0}处</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                {
                                                    item.accessory ? (
                                                        <div className="block-mini">
                                                            <div className="block-mini-title">
                                                                <h3>相关图片</h3>
                                                            </div>
                                                            <div className="block-mini-content">
                                                                <div className="IMGBox">
                                                                    {
                                                                        JSON.parse(item.accessory).map((obj,index)=>{
                                                                            var minImg = obj.dataImg.replace('.jpg', '_240x320.jpg').replace('.png', '_240x320.png').replace('.jpeg', '_240x320.jpeg');
                                                                            return (
                                                                                <div className="img" key={index} style={{background: `url(${minImg}) no-repeat 0 0`, backgroundSize: 'cover'}} onClick={()=>{
                                                                                    _this.setState({
                                                                                        selectImg: obj.dataImg,
                                                                                        imgShow: true,
                                                                                    },()=>{
                                                                                        document.getElementsByTagName('body')[0].style.cssText = 'overflow: hidden;';
                                                                                    });
                                                                                }}></div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : ''
                                                }
                                            </div>
                                        ) : ''
                                    }
                                </div>
                            )
                        })}
                    </div>) : ''
                }
                
                {
                    attachment && attachment.length > 0 ? (
                        <div>
                            <h2>证照凭证</h2>
                            <div className="blockBox">
                                <div className="IMGBox">
                                    {
                                        JSON.parse(attachment).map((item,index)=>{
                                            var minImg = item.dataImg.replace('.jpg', '_240x320.jpg').replace('.png', '_240x320.png').replace('.jpeg', '_240x320.jpeg');
                                            return (
                                                <div key={index}>
                                                    <div className="img" style={{background: `url(${minImg}) no-repeat 0 0`, backgroundSize: 'cover'}} onClick={()=>{
                                                        _this.setState({
                                                            selectImg: item.dataImg,
                                                            imgShow: true,
                                                        },()=>{
                                                            document.getElementsByTagName('body')[0].style.cssText = 'overflow: hidden;';
                                                        });
                                                    }}></div>
                                                    <div className="imgName">{item.imgName}</div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    ) : ''
                }                
                
                {
                    customerSign ? (
                        <div>
                            <h2>客户签字</h2>
                            <div className="blockBox" style={{ textAlign: 'center' }}>
                                {customerSign ? (<img src={JSON.parse(customerSign).dataImg} style={{height: '1.12rem' }} />) : ''}
                            </div>
                        </div>
                    ) : ''
                }

                {
                    customerSign ? (
                        <div>
                            <h2>运维签字</h2>
                            <div className="blockBox" style={{ textAlign: 'center' }}>
                                <img src={JSON.parse(bizSign).dataImg} style={{height: '1.12rem' }} />
                            </div>
                        </div>
                    ) : ''
                }
                {
                    this.state.imgShow ? (
                        <div className="image-big-box" onClick={()=>{
                            this.setState({
                                imgShow: false
                            },()=>{
                                document.getElementsByTagName('body')[0].style.cssText = 'overflow: auto;';
                            });
                        }}>
                            <div className="image-big-bg"></div>
                            <div className="image-big-img-box">
                                <div className="image-big-img" style={{backgroundImage: `url(${this.state.selectImg})`}}></div>
                            </div>
                        </div>
                    ) : ''
                }
            </div>
        );
    }
}
export default CarBillDetails;


// WEBPACK FOOTER //
// ./src/carBillDetails/index/index.js